"use client";

import type { ShopVerifiedLevel } from "@/modules/merchant/presentation/api/client";
import { VERIFIED_LEVEL_LABELS } from "@/modules/merchant/presentation/lib/shop-verification";
import { useMerchantShops } from "@/modules/merchant/presentation/store/use-merchant-shops";
import { SidebarGroup } from "@devhop/ui";
import { useParams } from "@tanstack/react-router";

/** คำอธิบายสั้น — อ่านง่ายใน sidebar แคบ */
const LEVEL_HINT: Record<ShopVerifiedLevel, string> = {
  none: "ຢືນຢັນລາຍການກ່ອນເພື່ອຂາຍ ແລະ POS",
  basic: "ຂາຍ, ສາງ, ຕັ້ງຄ່າພະນັກງານໄດ້",
  verified: "ໃຊ້ງານຄົບຖ້ວນ ລວມຂໍຊຳລະ",
};

const LEVEL_DOT: Record<ShopVerifiedLevel, string> = {
  none: "bg-[#f26522]",
  basic: "bg-[#f26522]",
  verified: "bg-[#004799]",
};

/** สถานะการยืนยันร้านใน sidebar — แบบสั้น อ่านง่าย */
export function ShopVerificationSidebarAlert() {
  const params = useParams({ strict: false });
  const shopId = params?.shopId as string | undefined;
  const { currentShop } = useMerchantShops(shopId);

  if (!shopId || !currentShop) return null;

  const level: ShopVerifiedLevel = currentShop.verifiedLevel ?? "none";
  const label = VERIFIED_LEVEL_LABELS[level];
  const hint = LEVEL_HINT[level];
  const headingId = `shop-verification-${shopId.slice(0, 8)}`;

  return (
    <SidebarGroup className="p-0 group-data-[collapsible=icon]:hidden">
      <section
        aria-labelledby={headingId}
        className="rounded-lg bg-muted/70 px-3 py-2.5"
      >
        <div className="flex items-start gap-2">
          <span
            className={`mt-1.5 size-2 shrink-0 rounded-full ${LEVEL_DOT[level]}`}
            aria-hidden
          />
          <div className="min-w-0">
            <p
              id={headingId}
              className="font-heading font-semibold text-foreground text-sm leading-snug"
            >
              {label}
            </p>
            <p className="mt-0.5 font-sans text-muted-foreground text-xs leading-snug">
              {hint}
            </p>
          </div>
        </div>
      </section>
    </SidebarGroup>
  );
}
